import "#legacy/shared/utilities/freeze_scrolling.js";

window.Modal = function (options) {
  options = jQuery.extend(
    {
      appendTo: "body",
      class: "default-modal",
      header: null,
      body: null,
      footer: null,

      closeConfirmation: false,
      clickOut: true,
      escOut: true,
      xOut: true,

      destroyOnHide: false,
      freezeScroll: true,
      focusInput: true,
    },
    window.ModalDefaults,
    options,
  );

  var publicInterface;
  var showing = true;

  var container = jQuery('<div class="modal sparkle-modal" aria-modal="true" role="dialog">')
    .addClass(options.class)
    .attr("id", options.id);
  var backdrop = jQuery("<div>").addClass("modal-backdrop");
  var dialog = jQuery('<div class="modal-dialog">');
  var header = jQuery('<div class="modal-header">');
  var body = jQuery('<div class="modal-body">');
  var footer = jQuery('<div class="modal-footer">');
  var closeButton = jQuery('<span class="modal-close-button modal-button-right" data-behaviour="close-modal">×</span>');

  if (options.backdrop) {
    options.backdrop.addClass("modal-backdrop");
  }
  // BEHAVIOUR

  container.on("click", '[data-behaviour="close-modal"]', confirmAndHide);

  backdrop.on("click", function (e) {
    if (options.clickOut && e.target === this) {
      confirmAndHide();
    }
  });

  jQuery(window).on("keyup", function (e) {
    if (options.escOut && e.which === 27) {
      confirmAndHide();
    }
  });

  // HELPER FUNCTIONS

  function setHeader(content) {
    header.empty().append(content); // Accept elements without duping in order to retain their handlers

    header.append(closeButton);
    if (!options.xOut) {
      closeButton.hide();
    }
  }

  function setBody(content) {
    // Accept elements without duping in order to retain their handlers, or the handlers of previous content
    body.children().detach();
    body.empty(); // Remove any text nodes that remain
    body.append(content);
  }

  function setFooter(content) {
    // Accept elements without duping in order to retain their handlers, or the handlers of previous content
    footer.children().detach();
    footer.append(content);
  }

  function show() {
    if (showing) {
      return;
    }
    triggerEvent("beforeShow");
    showing = true;
    container.addClass("active");

    if (options.freezeScroll) {
      Sparkle.Utilities.Scrolling.freeze();
    }

    if (options.focusInput) {
      container.find(":input:visible").not("[tabIndex=-1]").first().trigger("focus");
    }

    triggerEvent("show");
  }

  function confirmAndHide() {
    if (options.closeConfirmation) {
      var message = options.closeConfirmation === true ? "Are you sure?" : options.closeConfirmation;
      if (confirm(message)) {
        hide();
      }
    } else {
      hide();
    }
  }

  function hide() {
    if (!showing) {
      return;
    }
    triggerEvent("beforeHide");
    makeHidden();
    triggerEvent("hide");
    if (options.freezeScroll) {
      Sparkle.Utilities.Scrolling.unfreeze();
    }
    if (options.destroyOnHide) {
      destroy();
    }
  }

  function destroy() {
    triggerEvent("beforeDestroy");
    showing = false;
    window.Form?.disposeBehaviors?.(container[0]);
    container.remove();
    triggerEvent("destroy");
    if (options.freezeScroll) {
      Sparkle.Utilities.Scrolling.unfreeze();
    }
  }

  function triggerEvent(eventName) {
    // triggerHandler to avoid infinite looping when triggering events with matching function names
    jQuery(publicInterface).triggerHandler(eventName);
    container.trigger(eventName);
  }

  function setCloseConfirmation(value) {
    options.closeConfirmation = value;
  }

  function disableClose() {
    options.clickOut = false;
    options.escOut = false;
    options.xOut = false;
    closeButton.hide();
  }

  function enableClose() {
    options.clickOut = true;
    options.escOut = true;
    options.xOut = true;
    closeButton.show();
  }

  function enableFreezeScroll() {
    options.freezeScroll = true;
    Sparkle.Utilities.Scrolling.freeze();
  }
  function disableFreezeScroll() {
    options.freezeScroll = false;
    Sparkle.Utilities.Scrolling.unfreeze();
  }

  function isShowing() {
    return showing;
  }

  function makeHidden() {
    showing = false;
    container.removeClass("active");
  }

  // INITIALIZE

  makeHidden();
  dialog.append(header, body, footer);
  backdrop.append(dialog);
  container.append(backdrop);
  setHeader(options.header);
  setBody(options.body);
  setFooter(options.footer);
  jQuery(options.appendTo).append(container);

  // PUBLIC INTERFACE

  return (publicInterface = {
    setHeader: setHeader,
    setBody: setBody,
    setFooter: setFooter,
    setCloseConfirmation: setCloseConfirmation,
    disableClose: disableClose,
    enableClose: enableClose,
    enableFreezeScroll: enableFreezeScroll,
    disableFreezeScroll: disableFreezeScroll,
    show: show,
    hide: hide,
    destroy: destroy,
    container: container,
    dialog: dialog,
    header: header,
    body: body,
    footer: footer,
    backdrop: backdrop,
    isShowing: isShowing,
  });
};
